export default {
  text: '#fdfdfd',
  primary: '#d91f26',
  secondary: '#33ab48',
  background: 'black',
  backgroundSecondary: 'black',
  light: '#FFF',
  dark: '#202020',
}
